import "core-js/modules/es.array.reverse.js";
var _class, _OpenDataSoftCatalogStratum;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { ApiClient, fromCatalog } from "@opendatasoft/api-client";
import i18next from "i18next";
import { action, computed, runInAction, makeObservable } from "mobx";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import runLater from "../../../Core/runLater";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import { MetadataUrlTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import OpenDataSoftCatalogGroupTraits, { RefineTraits } from "../../../Traits/TraitsClasses/OpenDataSoftCatalogGroupTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import OpenDataSoftCatalogItem from "../CatalogItems/OpenDataSoftCatalogItem";

// "Valid" types which force some properties to be defined

export let OpenDataSoftCatalogStratum = (_class = (_OpenDataSoftCatalogStratum = class OpenDataSoftCatalogStratum extends LoadableStratum(OpenDataSoftCatalogGroupTraits) {
  static async load(catalogGroup) {
    if (!catalogGroup.url) throw "`url` must be set";
    const client = new ApiClient({
      domain: catalogGroup.url
    });
    const datasets = [];
    let facets;

    // If no facetFilters, try to get some facets
    if (catalogGroup.facetFilters && catalogGroup.facetFilters.length === 0 && !catalogGroup.flatten) {
      var _await$client$get$fac;
      facets = (_await$client$get$fac = (await client.get(fromCatalog().facets())).facets) === null || _await$client$get$fac === void 0 ? void 0 : _await$client$get$fac.filter(f => isValidFacet(f));
    }

    // If no facets (or we have facetFiles) - get datasets
    if (!facets || facets.length === 0) {
      // We can only fetch datasets in batch of 100
      let offset = 0;
      let totalDatasets;
      const limit = 100;
      let q = fromCatalog().datasets().limit(limit).orderBy("title asc")
      // Filter dataset with 'geo' or 'timeserie' features.
      // Possible values: calendar, geo, image, apiproxy, timeserie, and aggregate
      .where("features = \"geo\" OR features = \"timeserie\"");

      // If facet filters, use them to filter datasets
      if (catalogGroup.facetFilters && catalogGroup.facetFilters.length > 0) {
        q = q.refine(catalogGroup.facetFilters.map(f => "".concat(f.name, ":").concat(f.value)).join(","));
      }
      while (!isDefined(totalDatasets) || offset < totalDatasets) {
        var _catalog$total_count, _catalog$datasets;
        q = q.offset(offset);
        const catalog = await client.get(q);
        totalDatasets = (_catalog$total_count = catalog.total_count) !== null && _catalog$total_count !== void 0 ? _catalog$total_count : 0;
        (_catalog$datasets = catalog.datasets) === null || _catalog$datasets === void 0 || _catalog$datasets.forEach(response => {
          if (isValidDataset(response.dataset)) {
            datasets.push(response.dataset);
          }
        });
        offset += limit;
      }
    }
    return new OpenDataSoftCatalogStratum(catalogGroup, undefined, facets !== null && facets !== void 0 ? facets : [], datasets !== null && datasets !== void 0 ? datasets : []);
  }
  duplicateLoadableStratum(model) {
    return new OpenDataSoftCatalogStratum(model, this.facetName, this.facets, this.datasets);
  }
  constructor(catalogGroup, facetName, facets, datasets) {
    super();
    this.catalogGroup = catalogGroup;
    this.facetName = facetName;
    this.facets = facets;
    this.datasets = datasets;
    makeObservable(this);
  }
  get members() {
    return [...this.facets.map(f => this.getFacetId(f)), ...this.datasets.map(d => this.getDatasetId(d))];
  }
  createMembers() {
    this.facets.forEach(facet => this.createGroupFromFacet(facet));
    this.datasets.forEach(dataset => this.createMemberFromDataset(dataset));
  }

  /** Turn facet into OpenDataSoftCatalogGroup */
  createGroupFromFacet(facet) {
    var _facet$count;
    const layerId = this.getFacetId(facet);
    if (!layerId) {
      return;
    }
    const existingGroupModel = this.catalogGroup.terria.getModelById(OpenDataSoftCatalogGroup, layerId);
    let groupModel;
    if (existingGroupModel === undefined) {
      groupModel = new OpenDataSoftCatalogGroup(layerId, this.catalogGroup.terria, undefined);
      this.catalogGroup.terria.addModel(groupModel);
    } else {
      groupModel = existingGroupModel;
    }

    // Replace the stratum inherited from the parent group.
    groupModel.strata.delete(CommonStrata.definition);
    groupModel.setTrait(CommonStrata.definition, "name", "".concat(facet.name).concat(facet.count ? " (".concat((_facet$count = facet.count) !== null && _facet$count !== void 0 ? _facet$count : 0, ")") : ""));
    groupModel.setTrait(CommonStrata.definition, "url", this.catalogGroup.url);

    // Set OpenDataSoftDatasetStratum so it doesn't have to be loaded gain
    groupModel.strata.delete(OpenDataSoftCatalogStratum.stratumName);

    // If no more facets, set facetFilter
    if (!facet.facets || !Array.isArray(facet.facets) || facet.facets.length === 0) {
      groupModel.setTrait(CommonStrata.definition, "facetFilters", [createStratumInstance(RefineTraits, {
        name: this.facetName,
        value: facet.name
      })]);
    } else {
      groupModel.strata.set(OpenDataSoftCatalogStratum.stratumName, new OpenDataSoftCatalogStratum(groupModel, facet.name, facet.facets, []));
    }
  }

  /** Turn dataset into OpenDataSoftCatalogItem */
  createMemberFromDataset(dataset) {
    var _dataset$metas$defaul, _dataset$metas, _dataset$metas$defaul2, _dataset$metas2;
    const layerId = this.getDatasetId(dataset);
    if (!layerId) {
      return;
    }
    const existingItemModel = this.catalogGroup.terria.getModelById(OpenDataSoftCatalogItem, layerId);
    let itemModel;
    if (existingItemModel === undefined) {
      itemModel = new OpenDataSoftCatalogItem(layerId, this.catalogGroup.terria, undefined);
      this.catalogGroup.terria.addModel(itemModel);
      // Add older shareKey
      this.catalogGroup.terria.addShareKey(layerId, "".concat(this.catalogGroup.uniqueId, "/").concat(dataset.dataset_id));
    } else {
      itemModel = existingItemModel;
    }

    // Replace the stratum inherited from the parent group.
    itemModel.strata.delete(CommonStrata.definition);
    itemModel.setTrait(CommonStrata.definition, "datasetId", dataset.dataset_id);
    itemModel.setTrait(CommonStrata.definition, "url", this.catalogGroup.url);
    itemModel.setTrait(CommonStrata.definition, "name", (_dataset$metas$defaul = (_dataset$metas = dataset.metas) === null || _dataset$metas === void 0 || (_dataset$metas = _dataset$metas.default) === null || _dataset$metas === void 0 ? void 0 : _dataset$metas.title) !== null && _dataset$metas$defaul !== void 0 ? _dataset$metas$defaul : dataset.dataset_id);
    itemModel.setTrait(CommonStrata.definition, "description", (_dataset$metas$defaul2 = (_dataset$metas2 = dataset.metas) === null || _dataset$metas2 === void 0 || (_dataset$metas2 = _dataset$metas2.default) === null || _dataset$metas2 === void 0 ? void 0 : _dataset$metas2.description) !== null && _dataset$metas$defaul2 !== void 0 ? _dataset$metas$defaul2 : undefined);
    itemModel.setTrait(CommonStrata.definition, "metadataUrls", [createStratumInstance(MetadataUrlTraits, {
      title: i18next.t("models.openDataSoft.viewDatasetPage"),
      url: "".concat(this.catalogGroup.url, "/explore/dataset/").concat(dataset.dataset_id, "/information/")
    })]);
  }
  getDatasetId(dataset) {
    // Use OpenDataSoft server hostname for datasets, so we don't create multiple across facets
    return "".concat(this.catalogGroup.url ? URI(this.catalogGroup.url).hostname() : this.catalogGroup.uniqueId, "/").concat(dataset.dataset_id);
  }
  getFacetId(facet) {
    return "".concat(this.catalogGroup.uniqueId, "/").concat(facet.name);
  }
}, _defineProperty(_OpenDataSoftCatalogStratum, "stratumName", "openDataSoftCatalog"), _OpenDataSoftCatalogStratum), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createGroupFromFacet", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createGroupFromFacet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberFromDataset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberFromDataset"), _class.prototype), _class);
StratumOrder.addLoadStratum(OpenDataSoftCatalogStratum.stratumName);
export default class OpenDataSoftCatalogGroup extends UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(OpenDataSoftCatalogGroupTraits)))) {
  get type() {
    return OpenDataSoftCatalogGroup.type;
  }
  async forceLoadMetadata() {
    if (!this.strata.has(OpenDataSoftCatalogStratum.stratumName)) {
      const stratum = await OpenDataSoftCatalogStratum.load(this);
      runInAction(() => {
        this.strata.set(OpenDataSoftCatalogStratum.stratumName, stratum);
      });
    }
  }
  async forceLoadMembers() {
    const opendatasoftServerStratum = this.strata.get(OpenDataSoftCatalogStratum.stratumName);
    if (opendatasoftServerStratum) {
      await runLater(() => opendatasoftServerStratum.createMembers());
    }
  }
}
_defineProperty(OpenDataSoftCatalogGroup, "type", "opendatasoft-group");
export function isValidDataset(dataset) {
  return isDefined(dataset) && isDefined(dataset.dataset_id);
}
export function isValidFacet(facet) {
  var _facet$facets;
  return isDefined(facet) && isDefined(facet.name) && ((_facet$facets = facet.facets) !== null && _facet$facets !== void 0 ? _facet$facets : []).reduce((valid, current) => valid && isValidFacet(current), true);
}